import { styled } from '@mui/material/styles';
import absWebService from 'app/services/absWebService';
import clsx from 'clsx';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height', 'transform'], {
      duration: theme.transitions.duration.standard,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

function loadMainpage() {
  window.location.href="/";
}

function Logo(props) {
  const {type, colorname, className, imgClassName} = props;

  var apprestriction = absWebService.getAppRestrictionCookie();

  var logoname = "";
	if(type != null && type == 'long')
	{
		switch (colorname) {
			case "white":
					switch (apprestriction) {
					case "tl":
					  logoname = "tl_trans_white.svg";
					  break;
					case "eo":
					  logoname = "eo_trans_white.svg";
					  break;
					default:
					  logoname = "BS-weiss.svg";
					  break;
				  }
				break;
			case "black":
					switch (apprestriction) {
					case "tl":
					  logoname = "tl_trans_black.svg";
					  break;
					case "eo":
					  logoname = "eo_trans_black.svg";
					  break;
					default:
					  logoname = "BS-schwarz.svg";
					  break;
				  }			
				break;
			default:
					switch (apprestriction) {
					case "tl":
					  logoname = "tl_orig.svg";
					  break;
					case "eo":
					  logoname = "eo_orig.svg";
					  break;
					default:
					  logoname = "BS-DBlau.svg";
					  break;
				  }
				break;
		}	
	}
	else
	{
		switch (colorname) {
			case "white":
					switch (apprestriction) {
					case "tl":
					  logoname = "tl_trans_white.svg";
					  break;
					case "eo":
					  logoname = "eo_trans_white.svg";
					  break;
					default:
					  logoname = "BS-BM-Raster-weiss.svg";
					  break;
				  }				
				break;
			case "black":
					switch (apprestriction) {
					case "tl":
					  logoname = "tl_trans_black.svg";
					  break;
					case "eo":
					  logoname = "eo_trans_black.svg";
					  break;
					default:
					  logoname = "BS-BM-Raster-schwarz.svg";
					  break;
				  }
				break;
			default:
					switch (apprestriction) {
					case "tl":
					  logoname = "tl_orig.svg";
					  break;
					case "eo":
					  logoname = "eo_orig.svg";
					  break;
					default:
					  logoname = "BS-BM-DBlau.svg";
					  break;
				  }				
				break;
		}	
	}

  return (
    <Root className={clsx("flex items-center group",className)} onClick={loadMainpage}>
      <img className={clsx(imgClassName,"logo-icon py-4 w-auto max-w-192 transform group-hover:scale-110 object-contain")} src={"assets/images/logos/"+logoname} alt="logo" />
    </Root>
  );
}

export default Logo;
